"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionTile = void 0;
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var Pictogram_1 = require("../Pictogram/Pictogram");
/**
 * Accordion Tiles
 * @param props
 * @description
 * A more complex heading for the accordion navigation
 */
var AccordionTile = function (props) {
    var className = props.className, heading = props.heading, pictogramName = props.pictogramName, subHeading = props.subHeading;
    var pictogramComponent;
    var subHeadingComponent;
    if (pictogramName) {
        pictogramComponent = (React.createElement("div", { className: "tile-pictogram" },
            React.createElement(Pictogram_1.Pictogram, { name: pictogramName })));
    }
    if (subHeading) {
        subHeadingComponent = (React.createElement("div", { className: "tile-secondary" }, subHeading));
    }
    var classNames = (0, classnames_1.default)('accordion-tile', className !== null && className !== void 0 ? className : className);
    return (React.createElement("div", { className: classNames },
        pictogramComponent,
        React.createElement("div", { className: "tile-content" },
            React.createElement("div", { className: "tile-heading" }, heading),
            subHeadingComponent)));
};
exports.AccordionTile = AccordionTile;
/* tslint:disable:no-string-literal */
exports.AccordionTile['propTypes'] = {
    className: PropTypes.string,
    heading: PropTypes.string.isRequired,
    pictogramName: PropTypes.string,
    subHeading: PropTypes.string,
};
/* tslint:enable:no-string-literal */ 
